import { CurrencyIso } from '../../../converters/convertCurrencyIso';
import { RootState } from '../../RootState';
import selectRequiredSettings from './selectRequiredSettings';

const selectCurrencyIso = (state: RootState): CurrencyIso => {
  const settings = selectRequiredSettings(state);
  return settings.currencyIso;
};

export default selectCurrencyIso;
